const AuditTrailPermissions = {
  VIEW_AUDIT_LOG_PAGE: 'audit_log_page_read',
};

export default AuditTrailPermissions;
